import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, IconButton, Tooltip, Typography } from "@mui/material";
import { Close, VerticalSplit } from "@mui/icons-material";
import api from "../../../api";

export default function PdfComparisonView({ importId, onClose }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const blobRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const fetchPdf = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get(`/admin/question-bank/import/${importId}/paper`, {
          responseType: "blob",
        });
        if (!cancelled) {
          const url = URL.createObjectURL(res.data);
          blobRef.current = url;
          setBlobUrl(url);
        }
      } catch (err) {
        if (!cancelled) {
          setError("Could not load PDF");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchPdf();

    return () => {
      cancelled = true;
      if (blobRef.current) {
        URL.revokeObjectURL(blobRef.current);
      }
    };
  }, [importId]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderLeft: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          py: 0.5,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "grey.50",
        }}
      >
        <Typography variant="subtitle2" sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
          Original PDF
        </Typography>
        <Tooltip title="Close PDF view">
          <IconButton size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flex: 1, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {loading && <CircularProgress size={28} />}
        {error && (
          <Typography variant="body2" color="error" sx={{ p: 2 }}>
            {error}
          </Typography>
        )}
        {blobUrl && (
          <iframe
            src={blobUrl}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Original PDF"
          />
        )}
      </Box>
    </Box>
  );
}

export function PdfToggleButton({ showPdf, onToggle }) {
  return (
    <Tooltip title={showPdf ? "Hide PDF" : "Show original PDF side-by-side"}>
      <IconButton onClick={onToggle} color={showPdf ? "primary" : "default"} size="small">
        <VerticalSplit />
      </IconButton>
    </Tooltip>
  );
}
